import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CurrencyMaskDirective } from './currencyMask.directive';

@NgModule({
    imports: [CommonModule, FormsModule, CurrencyMaskDirective],
    exports: [CurrencyMaskDirective],
})
export class CurrencyMaskModule {}
